export default {
  memberships: [],
  links: {},
  pagination: {
    page: 1,
    perPage: 10,
    pageCount: 1,
  },
};
